import { Component, OnInit, OnDestroy, ViewChild, AfterViewInit } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';

import { BehaviorSubject, Subject } from 'rxjs';

import { SearchService, BreakpointService, BreadcrumbService, Preferences } from '@library/core/services';

import { AccountService } from './account.service';
import { Account } from './account';
import { Router } from '@angular/router';
import { MatSelectionList } from '@angular/material/list';
import { IGenericType } from '@library/common/generictype';

@Component({
  selector: 'lib-account',
  styleUrls: [ './account.component.scss' ],
  templateUrl: './account.component.html',
})
export class AccountComponent implements OnInit, OnDestroy, AfterViewInit {
   _loading: number;
   _onDestroy: Subject<void> = new Subject();

   list$ = new BehaviorSubject( null );

   @ViewChild(MatPaginator) paginator: MatPaginator;

   @ViewChild( 'accountSelector', { read: MatSelectionList } ) accountSelector: MatSelectionList;

   get pageSize() { return this.prefs.getPageSize( 'accounts' ); }
   set pageSize( value ) { this.prefs.setPageSize( 'accounts', value ); }

   page = 0;
   get startIndex() { return this.page * this.pageSize; }
   get endIndex() { return this.startIndex + this.pageSize; }

   get filterString(): string {
      return ( this.search.text.value || '' ).trim().toLowerCase();
   }

   private _fromKs = false;

   constructor(
      public accountService: AccountService,
      public search: SearchService,
      public breakpoints: BreakpointService,
      public router: Router,

      private prefs: Preferences,
      private breadcrumbs: BreadcrumbService,
   ) {
      if ( this.router.getCurrentNavigation().extras.state?.fromKs ) {
         this._fromKs = true;
      }
   }

   ngOnInit() {
      this.initializeData();

      this.search.enterKeyUp.subscribe(( isEnterKey ) => {
         if ( isEnterKey ) {
            this.search.blur();
            this.accountSelector.focus();
         }
      });
   }

   ngAfterViewInit(): void {
      if ( this._fromKs ) {
         this.search.searchActive$.next( true );
      }
   }

   initializeData() {
      this.accountService.list.subscribe( list => this.list$.next( list ));
      this.breadcrumbs.newCrumb({ label: 'User', path: '/user' });
      this.breadcrumbs.addCrumble( 'Accounts' );
      this.search.showSearch = true;
   }

   ngOnDestroy() {
      this._onDestroy.next();
      this._onDestroy.complete();
   }

   switch( id: number ) {
      this._loading = id;
      this.accountService.switchAccount( id ).subscribe( _ => this._loading = null );
   }

   bookmark( a: Account ): void {
      this.accountService.bookmark( a );
      this.prefs.refresh$.subscribe( _ => this.initializeData() );
   }

   toSwitch(selected: boolean, account: IGenericType) {
      if ( selected ) {
         this.switch( account.id );
      }
   }
}
